import React from 'react';
import { getDate } from 'date-fns';

import { Tooltip } from '@components/common';

interface CustomCalendarDayProps {
	day: number;
	date: Date;
	isDisabled: boolean;
	tooltipText: string;
}

const CustomCalendarDay: React.FC<CustomCalendarDayProps> = ({
	date,
	isDisabled,
	tooltipText,
}) => {
	return (
		<Tooltip
			content={tooltipText}
			isDisabled={!isDisabled}
			placement='top'
		>
			<span>
				{getDate(date)}
			</span>
		</Tooltip>
	);
};

export default CustomCalendarDay;
